import React, {createContext, useState, useContext, useCallback, useMemo} from 'react';

const SidebarContext = createContext()

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider = ({children}) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const toggleSidebar = useCallback(() => {
        setIsSidebarOpen(prev => !prev)
    }, []);
    const value = useMemo(() => ({
        isSidebarOpen,
        toggleSidebar,
    }), [isSidebarOpen, toggleSidebar]);
    return (
        <SidebarContext.Provider value ={value}>
            {children}
        </SidebarContext.Provider>
    )
}

